import _Model from "./_Model";
import DocumentationDisplaySelector from "./DocumentationDisplaySelector";
import LicenseModelCategory from "./LicenseModelCategory";

export default class SoftwareInfo extends _Model {
  constructor(json) {
    super(json);
    this.key = SoftwareInfo.getOrDefault(json, 'key', '');
    this.name = SoftwareInfo.getOrDefault(json, 'name', '');
    this.documentationDisplaySelector = SoftwareInfo.getMappedOrDefault(json, 'documentationDisplaySelector', null, data => new DocumentationDisplaySelector(data));
    this.availableLicenseModels = SoftwareInfo.getMappedOrDefault(json, 'availableLicenseModels', [], data => {
      try {
        return (data || []).map(s => new LicenseModelCategory(s));
      } catch(e) {}
      return [];
    });
    this.defaultLicenseModel = SoftwareInfo.getOrDefault(json, 'defaultLicenseModel', '');
  }
}
